import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState = {
  data:{}
}

export const initSigninSlice = createSlice({
  name: 'signin',
  initialState,
  reducers: {
    setData: (state,action) => {
      state.data = action.payload;
    }
  },
})

export const { setData } = initSigninSlice.actions;

export default initSigninSlice.reducer;